import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import users from '../../../../users';

const pickerDateFormat = 'YYYY-M-D';
const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'Outcome',
  mixins: [users, validationMixin],
  props: ['dataObj'],
  components: {
    CameraComp: require('@/components/uploadPictureToActivityAttachment/uploadPictureToActivityAttachment.vue').default,
    SelectEmployeeComp: require('@/customcontrols/SelectEmployee/selectEmployee.vue').default,
  },
  data: function () {
    return {
      outcomeData: {

      },
      message: '',
      employees: [],
      employeeId: null,
    }
  },
  validations: {
    employeeId: {
      required,
    }
  },
  computed: {
    formattedDate: function () {
      return this.$store.state.csAppsOfflineMode ? this.formatDateUI(moment(this.outcomeData.outcome.outcomeDate)) : this.formatDateUI(moment(this.outcomeData.outcome.date));
    },
  },
  watch: {
    employeeId: function (val) {
      if (!this.outcomeData || !this.outcomeData.outcome)
        return;

      if (this.$store.state.csAppsOfflineMode) {
        if (val == null)
          this.outcomeData.outcome.employeeData = -1;
        else
          this.outcomeData.outcome.employeeData = this.employees.filter(a => a.employeeId == val.employeeId)[0];
      }
      else {
        if (val == null)
          this.outcomeData.outcome.employeeData.employeeId = -1;
        else
          this.outcomeData.outcome.employeeData.employeeId = this.employeeId;
      }
    }
  },
  created() {
    this.outcomeData = this.dataObj;
    //console.log(this.outcomeData);

    this.getEmployees();
  },
  methods: {
    getValidationClass(objName) {
      const field = this.$v[objName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    formatDateUI(date) {
      return moment(date).format(uiDateFormat);
    },
    formatDateYYYYMMDD(date) {
      return moment(date, 'YYYY-MM-DD');
    },
    getEmployees() {
      if (this.$store.state.csAppsOfflineMode) {
        this.employees = this.$store.state.offlineApplicationsData.activityLookups[this.dataObj.activityId]['employee'];
        this.employeeId = this.$store.getters.getUserProfile.employeeId;//this.outcomeData.outcome.employeeData.employeeId;
        return;
      }

      //var parameter = {
      //  Filters: this.outcomeData.outcome.employeeData,
      //  Options: { pageSize: 10000, total: 0, page: 1 }
      //};

      //parameter.Filters.isFieldWorker = true;

      var parameter = {
        Filters: { isFieldWorker: true },
        Options: { pageSize: 10000, total: 0, page: 1 }
      };


      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/InvestigationOutcomeActivity/GetEmployees', parameter)
        .then(response => {
          if (response.status == 200) {
            this.employees = response.data.items;
            this.employeeId = this.$store.getters.getUserProfile.employeeId;//this.outcomeData.outcome.employeeData.employeeId;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    validateAppData() {
      if (this.outcomeData == null || this.outcomeData.outcome == null || this.outcomeData.outcome.employeeData == null ||
        this.outcomeData.outcome.employeeData.employeeId == null || this.outcomeData.outcome.employeeData.employeeId < 0) {
        this.$alertMsg(this.$t('messages.employeeNotSelected'));
        return;
      }

      this.$v.employeeId.$touch();

      if (this.$v.employeeId.$invalid) {
        return false;
      }

      return true;
    }
  }

}
